import { Suspense, lazy, ElementType } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const RegisterPage = Loadable(lazy(() => import('../pages/auth/RegisterPage')));
export const VerifyCodePage = Loadable(lazy(() => import('../pages/auth/VerifyCodePage')));
export const NewPasswordPage = Loadable(lazy(() => import('../pages/auth/NewPasswordPage')));
export const ResetPasswordPage = Loadable(lazy(() => import('../pages/auth/ResetPasswordPage')));

// TEST RENDER PAGE BY ROLE
export const PermissionDeniedPage = Loadable(
  lazy(() => import('../pages/dashboard/PermissionDeniedPage'))
);

// BLANK PAGE
export const BlankPage = Loadable(lazy(() => import('../pages/dashboard/BlankPage')));
export const FaqsPage = Loadable(lazy(() => import('../pages/FaqsPage')));
export const AboutPage = Loadable(lazy(() => import('../pages/AboutPage')));
export const Contact = Loadable(lazy(() => import('../pages/ContactPage')));
// export const PageOne = Loadable(lazy(() => import('../pages/PageOne')));
// export const PageTwo = Loadable(lazy(() => import('../pages/PageTwo')));
// export const PageThree = Loadable(lazy(() => import('../pages/PageThree')));
// export const PageFour = Loadable(lazy(() => import('../pages/PageFour')));
// export const PageFive = Loadable(lazy(() => import('../pages/PageFive')));
// export const PageSix = Loadable(lazy(() => import('../pages/PageSix')));

export const Page500 = Loadable(lazy(() => import('../pages/Page500')));
export const Page403 = Loadable(lazy(() => import('../pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/Page404')));

export const TncPage = Loadable(lazy(() => import('../pages/TnC')));
export const PrivacyPolicyPage = Loadable(lazy(() => import('../pages/PrivacyPolicy')));
// export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
// export const FaqsPage = Loadable(lazy(() => import('../pages/FaqsPage')));
// export const AboutPage = Loadable(lazy(() => import('../pages/AboutPage')));
// export const Contact = Loadable(lazy(() => import('../pages/ContactPage')));

export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));
export const MaintenancePage = Loadable(lazy(() => import('../pages/MaintenancePage')));

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazy(() => import('../pages/dashboard/GeneralAppPage')));
export const UserNotifListing = Loadable(
  lazy(() => import('../sections/@dashboard/general/analytics/UserNotifListing'))
);

export const UserActListing = Loadable(
  lazy(() => import('../sections/@dashboard/general/analytics/UserActListing'))
);
export const UserFileListing = Loadable(
  lazy(() => import('../sections/@dashboard/general/analytics/UserFileListing'))
);

export const Generalhomepage = Loadable(lazy(() => import('../pages/dashboard/Generalhomepage')));
export const GeneralAnalyticsPage = Loadable(
  lazy(() => import('../pages/dashboard/GeneralAnalyticsPage'))
);

// DASHBOARD: USER
export const UserProfilePage = Loadable(lazy(() => import('../pages/dashboard/UserProfilePage')));


export const Profile = Loadable(  lazy(() => import('../sections/@dashboard/user/profile/home/Profile')) );
export const ProfileFriends = Loadable(  lazy(() => import('../sections/@dashboard/user/profile/ProfileFriends')) );
export const ProfileFollowers = Loadable(  lazy(() => import('../sections/@dashboard/user/profile/ProfileFollowers')) );
export const ProfileBlog = Loadable(  lazy(() => import('../sections/@dashboard/user/profile/ProfileBlog')) );
export const ProfileFavorite = Loadable(  lazy(() => import('../sections/@dashboard/user/profile/ProfileFavorite')) );
export const ProfileFavoritePost = Loadable(  lazy(() => import('../sections/@dashboard/user/profile/ProfileFavoritePost')) );
export const ProfileFavoriteBlog = Loadable(  lazy(() => import('../sections/@dashboard/user/profile/ProfileFavoriteBlog')) );



export const UserCardsPage = Loadable(lazy(() => import('../pages/dashboard/UserCardsPage')));
export const UserListPage = Loadable(lazy(() => import('../pages/dashboard/UserListPage')));
export const UserAccountPage = Loadable(lazy(() => import('../pages/dashboard/UserAccountPage')));
export const UserCreatePage = Loadable(lazy(() => import('../pages/dashboard/UserCreatePage')));
export const UserEditPage = Loadable(lazy(() => import('../pages/dashboard/UserEditPage')));
export const ProfilePostPage = Loadable(lazy(() => import('../pages/dashboard/ProfilePostPage')));

export const ExplorePage = Loadable(lazy(() => import('../pages/dashboard/ExplorePage')));
// DASHBOARD: BLOG
export const BlogPostsPage = Loadable(lazy(() => import('../pages/dashboard/BlogPostsPage')));
export const BlogPostPage = Loadable(lazy(() => import('../pages/dashboard/BlogPostPage')));
export const BlogNewPostPage = Loadable(lazy(() => import('../pages/dashboard/BlogNewPostPage')));
export const BlogEditPostPage = Loadable(lazy(() => import('../pages/dashboard/BlogEditPostPage')));
export const BlogPostListPage = Loadable(lazy(() => import('../pages/dashboard/BlogPostListPage')));

// DASHBOARD: APP
export const ChatPage = Loadable(lazy(() => import('../pages/dashboard/ChatPage')));
export const MailPage = Loadable(lazy(() => import('../pages/dashboard/MailPage')));
export const CalendarPage = Loadable(lazy(() => import('../pages/dashboard/CalendarPage')));
export const KanbanPage = Loadable(lazy(() => import('../pages/dashboard/KanbanPage')));

export const LogoutPage = Loadable(lazy(() => import('../pages/dashboard/LogoutPage')));

// const Notifications = Loadable(lazy(() => import('../pages/app/Notifications')));
